<template>
  <qx-card-form title="法人/实际控制人信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="140px"
    />
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '实际控制人身份证',
            value: 'identificationPicture',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '实际控制人姓名',
            value: 'actualController',
            type: 'input',
          },
          {
            label: '实际控制人证件号',
            value: 'identification',
            type: 'input',
          },
          {
            label: '实际控制人电话',
            value: 'actualControllerPhone',
            type: 'input',
          },
        ],
        rules: {
          identificationPicture: [ // 实际控制人身份证
            { required: true, message: '请选择实际控制人身份证', trigger: 'blur' },
          ],
          actualController: [ // 实际控制人姓名
            { required: true, message: '请输入实际控制人姓名', trigger: 'blur' },
          ],
          identification: [ // 实际控制人证件号
            { required: true, message: '请输入实际控制人证件号', trigger: 'blur' },
          ],
          actualControllerPhone: [ // 实际控制人电话
            { required: true, message: '请输入实际控制人电话', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 营业执照
        if (formData.identificationPicture[0]) {
          formData.identificationPictureUrl = formData.identificationPicture[0].url;
          formData.identificationPicture = formData.identificationPicture[0].id;
        } else {
          delete formData.identificationPicture;
        }
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      if (data.tenantInfo) {
        data = data.tenantInfo;
      }
      // 营业执照
      if (data.identificationPicture && data.identificationPictureUrl) { // id和地址都有
        data.identificationPicture = [{
          id: data.identificationPicture,
          url: data.identificationPictureUrl,
        }];
      } else if (data.identificationPicture) { // 只有id
        const urlRes = await getFileUrl({
          flowIds: data.identificationPicture,
          _GRID_TYPE: 'jq',
        });
        data.identificationPicture = [{
          id: data.identificationPicture,
          url: urlRes.rows[0] ? urlRes.rows[0].fullPath : '',
        }];
      } else {
        data.identificationPicture = [];
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
